import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction";

const DialogDeleteStudentConfirmation = ({
	dialog, space, selectedStudents, deleteStudentsFromReservationList
}) => {
	return (
		<SpaceDialogAction
			dialog={dialog}
			title={`¿Deseas eliminar ${selectedStudents.onlyOneStudentSelected() ? "al alumno" : "a los alumnos"} de la reserva
			del espacio ${space.name}?`}
			content="Recuerda que al eliminar un alumno, podrás agregarlo nuevamente a esta u otra reserva desde el botón Agregar alumno(s).">
			<CustomButton
				variant="secondary"
				width="120px"
				text="No, cancelar"
				onClick={dialog.hide} />
			<CustomButton
				width="120px"
				text="Si, eliminar"
				onClick={deleteStudentsFromReservationList} />
		</SpaceDialogAction>
	);
}

export default DialogDeleteStudentConfirmation;